import { differenceInYears } from 'date-fns';

export const useIsNotMajor = (dob: Date | undefined) => {
  return dob && differenceInYears(new Date(), dob) < 18;
};
